module.exports = __webpack_public_path__ + "static/TitilliumWeb-Regular-5cc3bb6494875e0a712a664041175347.woff2";